module.exports = __webpack_public_path__ + "static/media/_somaliland.6a792d0a.png";